import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useShop } from "@/context/ShopContext";
import { formatINR, optImg } from "@/lib/api";

const ProductCard = ({ product, index = 0 }) => {
    const { toggleWishlist, isWishlisted } = useShop();
    const wishlisted = isWishlisted(product.id);

    return (
        <div
            className="group rise-in"
            style={{ animationDelay: `${Math.min(index * 60, 400)}ms` }}
            data-testid={`product-card-${product.id}`}
        >
            <div className="relative">
                {/* Jharokha framed image */}
                <div className="relative bg-white border border-[color:var(--border-gold)] shine-hover overflow-hidden">
                    <Link to={`/product/${product.id}`} className="block">
                        <div className="aspect-[3/4] overflow-hidden">
                            <img
                                src={(product.image || "").includes("/image/upload/") && (product.image || "").includes("res.cloudinary.com") ? product.image.replace("/image/upload/", "/image/upload/f_auto,q_auto,w_600/") : product.image}
                                alt={product.name}
                                loading="lazy"
                                decoding="async"
                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                    </Link>
                    <button
                        onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
                        className="absolute top-4 right-4 w-9 h-9 rounded-full bg-[color:var(--ivory)] border border-[color:var(--border-gold)] flex items-center justify-center hover:bg-[color:var(--maroon)] transition-colors duration-300"
                        aria-label="Wishlist"
                        data-testid={`wishlist-toggle-${product.id}`}
                    >
                        <Heart
                            size={15}
                            strokeWidth={1.6}
                            className={wishlisted ? "text-[color:var(--maroon)] fill-[color:var(--maroon)] group-hover:text-[color:var(--ivory)] group-hover:fill-[color:var(--ivory)]" : "text-[color:var(--maroon)] group-hover:text-[color:var(--ivory)]"}
                        />
                    </button>
                    {product.tag && (
                        <span className="absolute top-4 left-4 bg-[color:var(--gold)] text-[color:var(--maroon-dark)] text-[10px] font-ui font-semibold tracking-widest-x uppercase px-2.5 py-1">
                            {product.tag}
                        </span>
                    )}
                    {product.stock !== null && product.stock !== undefined && product.stock <= 0 && (
                        <span className="absolute bottom-4 left-4 bg-[color:var(--maroon)] text-[color:var(--ivory)] text-[10px] font-ui font-semibold tracking-widest-x uppercase px-2.5 py-1">
                            Out of Stock
                        </span>
                    )}
                    {product.stock !== null && product.stock !== undefined && product.stock > 0 && product.stock <= 10 && (
                        <span className="absolute bottom-4 left-4 bg-[color:var(--copper)] text-[color:var(--ivory)] text-[10px] font-ui font-semibold tracking-widest-x uppercase px-2.5 py-1">
                            Only {product.stock} left
                        </span>
                    )}
                </div>
            </div>

            <div className="pt-5 text-center">
                <p className="font-ui text-[10px] tracking-widest-x uppercase text-[color:var(--copper)]">
                    {product.material} · {product.region}
                </p>
                <Link to={`/product/${product.id}`}>
                    <h3 className="font-heading text-xl text-[color:var(--maroon)] mt-1 hover:text-[color:var(--copper)] transition-colors duration-300">
                        {product.name}
                    </h3>
                </Link>
                <div className="mt-2 flex items-center justify-center gap-3">
                    <span className="font-body text-base text-[color:var(--gold)] font-semibold">{formatINR(product.price)}</span>
                    {product.original_price && (
                        <span className="font-body text-sm text-[color:var(--ink-muted)] line-through">{formatINR(product.original_price)}</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
